export const pad = (x: number | string, pad = 2) =>
  String(x).padStart(pad, "0");
